import React, { useState } from "react";
import { useDesfaseReloj } from "../../hooks/useDesfaseReloj";
import { RelojVivo } from "./RelojVivo";
import { ModalDesfaseReloj } from "./ModalDesfaseReloj";
import {
    CONTEXTO_RELOJ_BODEGA,
    CONTEXTO_RELOJ_PRODUCCION,
    NOMBRES_RELOJ,
} from "./contextosReloj";
import "./styles/RelojDesfase.css";

// Reloj de un contexto: la fecha y hora con desfase corriendo, que al hacer
// clic abre su configuración e historial. No aparece mientras falte el
// correlativo inicial de pallets, que define hasta qué año puede ir hacia atrás
export const RelojDesfase = ({ contexto, onCambioGuardado }) => {
    const reloj = useDesfaseReloj({ contexto, onCambioGuardado });

    if (!reloj.correlativoConfigurado) return null;

    let claseEtiqueta = "reloj-desfase__etiqueta";

    if (!reloj.esTiempoActual) {
        claseEtiqueta += " reloj-desfase__etiqueta--desfase";
    }

    return (
        <div className="reloj-desfase">
            <RelojVivo
                diferenciaMs={reloj.diferenciaMs}
                esTiempoActual={reloj.esTiempoActual}
                onClick={reloj.AbrirModal}
            />

            <small className={claseEtiqueta}>
                {NOMBRES_RELOJ[contexto]}
                {reloj.esTiempoActual ? "" : " · Con desfase"}
            </small>

            <ModalDesfaseReloj reloj={reloj} />
        </div>
    );
};

// Al guardar un cambio del reloj la pantalla se vuelve a montar, para que
// cargue sus datos con la nueva fecha y hora
const PantallaConReloj = ({
    contexto,
    esFormulario,
    Pantalla,
    pantallaProps,
}) => {
    const [version, setVersion] = useState(0);

    let clasePantalla = "reloj-desfase__pantalla";

    if (esFormulario) {
        clasePantalla += " reloj-desfase__pantalla--formulario";
    }

    return (
        <div className={clasePantalla}>
            <RelojDesfase
                contexto={contexto}
                onCambioGuardado={() => setVersion((previa) => previa + 1)}
            />

            <Pantalla key={version} {...pantallaProps} />
        </div>
    );
};

// Envuelve una pantalla para el router. El resultado se guarda por componente,
// porque devolver uno nuevo en cada render volvería a montar la pantalla.
// esFormulario es para las pantallas armadas con CardForm, que arrancan con la
// tarjeta pegada al título y no dejan lugar al reloj
const crearConReloj = (contexto) => {
    const pantallas = new Map();

    return (Pantalla, { esFormulario = false } = {}) => {
        if (!pantallas.has(Pantalla)) {
            pantallas.set(Pantalla, (props) => (
                <PantallaConReloj
                    contexto={contexto}
                    esFormulario={esFormulario}
                    Pantalla={Pantalla}
                    pantallaProps={props}
                />
            ));
        }

        return pantallas.get(Pantalla);
    };
};

export const conRelojProduccion = crearConReloj(CONTEXTO_RELOJ_PRODUCCION);
export const conRelojBodega = crearConReloj(CONTEXTO_RELOJ_BODEGA);
